import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-data-grid';

class RollOverRowRenderer extends PureComponent {
    static propTypes = {
        row: PropTypes.object
    }

    setScrollLeft(scrollBy) {
        // if you want freeze columns to work, you need to make sure you implement this as apass through
        this.row.setScrollLeft(scrollBy);
    }

    getComponentReference(currentComponent) {
        this.row = currentComponent;
    }

    render() {
        const height = this.props.row.length * 23;
        return (<Row ref={node => this.getComponentReference(node)} {...this.props} height={height} />);
    }
}

export default RollOverRowRenderer;



// WEBPACK FOOTER //
// ./app/components/renderers/rollover-row-renderer/index.js